import { Button } from '#/components/ui/button';
import { CarouselItem } from '#/components/ui/carousel';
import React from 'react';

import type { ServiceMenus } from '../api/global-config';
import { buttonStyles } from '../styles';
import { SvgImgIllustCard } from '../svg/kabu-category/img-illust-card';
import { SvgImgIllustDenki } from '../svg/kabu-category/img-illust-denki';
import { SvgImgIllustFurusato } from '../svg/kabu-category/img-illust-furusato';
import { SvgImgIllustGas } from '../svg/kabu-category/img-illust-gas';
import { SvgImgIllustHikari } from '../svg/kabu-category/img-illust-hikari';
import { SvgImgIllustKabukatsu } from '../svg/kabu-category/img-illust-kabukatsu';
import { SvgImgIllustMobile } from '../svg/kabu-category/img-illust-mobile';
import { SvgImgIllustWater } from '../svg/kabu-category/img-illust-water';
import { SvgImgTitleCard } from '../svg/kabu-category/img-title-card';
import { SvgImgTitleDenki } from '../svg/kabu-category/img-title-denki';
import { SvgImgTitleFurusato } from '../svg/kabu-category/img-title-furusato';
import { SvgImgTitleGas } from '../svg/kabu-category/img-title-gas';
import { SvgImgTitleHikari } from '../svg/kabu-category/img-title-hikari';
import { SvgImgTitleKabukatsu } from '../svg/kabu-category/img-title-kabukatsu';
import { SvgImgTitleMobile } from '../svg/kabu-category/img-title-mobile';
import { SvgImgTitleWater } from '../svg/kabu-category/img-title-water';
import { SiteModalPlusMember } from './site-modal-plus-member';

type SvgComponent = React.FC<{ className: string; 'aria-label': string }>;
type KabuCategoryKeys = 'denki' | 'gas' | 'mobile' | 'hikari' | 'water' | 'furusato' | 'card' | 'kabukatsu';

type CategoryAssetPair = {
  title: SvgComponent;
  illustration: SvgComponent;
};

type CategoryAssets = Record<KabuCategoryKeys, CategoryAssetPair>;

const categoryAssets: CategoryAssets = {
  denki: { title: SvgImgTitleDenki, illustration: SvgImgIllustDenki },
  gas: { title: SvgImgTitleGas, illustration: SvgImgIllustGas },
  mobile: { title: SvgImgTitleMobile, illustration: SvgImgIllustMobile },
  hikari: { title: SvgImgTitleHikari, illustration: SvgImgIllustHikari },
  water: { title: SvgImgTitleWater, illustration: SvgImgIllustWater },
  furusato: { title: SvgImgTitleFurusato, illustration: SvgImgIllustFurusato },
  card: { title: SvgImgTitleCard, illustration: SvgImgIllustCard },
  kabukatsu: { title: SvgImgTitleKabukatsu, illustration: SvgImgIllustKabukatsu },
};

export const SiteFooterCarouselItem = (props: { serviceMenus: ServiceMenus }) => {
  const { serviceMenus } = props;

  const numberMap: Record<string, string> = {
    '/denki': '1',
    '/gas': '1',
    '/mobile': '10',
    '/hikari': '5',
    '/water': '5',
    '/furusato': '1',
    '/card': '1',
    '/kabukatsu': '',
  };

  const dummyServiceMenus = [
    { href: '/denki', label: '電気' },
    { href: '/gas', label: 'ガス' },
    { href: '/mobile', label: 'モバイル' },
    { href: '/hikari', label: '光' },
    { href: '/water', label: '水' },
    { href: '/furusato', label: 'ふるさと' },
    { href: '/card', label: 'カード' },
    { href: '/kabukatsu', label: 'カブ活' },
  ];

  return (
    <>
      {serviceMenus &&
        serviceMenus.length > 0 &&
        dummyServiceMenus.map((item) => {
          const key = item.href.replace('/', '') as KabuCategoryKeys;
          const ImgTitle = categoryAssets[key]['title'];
          const ImgIllustration = categoryAssets[key]['illustration'];
          return (
            <CarouselItem className="relative ml-4 min-w-0 shrink-0 grow-0 basis-auto pl-0" key={item.href}>
              <div className="h-full w-[172px] flex-none snap-center rounded-lg bg-white px-4 py-6">
                <div className="flex flex-col items-center gap-4">
                  {ImgTitle && <ImgTitle className="h-[18px] flex-none" aria-label={`KABU&${item.label}`} />}
                  {ImgIllustration && (
                    <ImgIllustration className="my-3 w-[90px] flex-none" aria-label={`KABU&${item.label}のイラスト`} />
                  )}
                  <div className="space-y-2">
                    <p className="text-brand text-center">
                      {item.href === '/kabukatsu' ? (
                        <span className="text-caption-s block py-[5px]">お買い物やサービス申し込みで</span>
                      ) : (
                        <>
                          <span className="text-caption-s">
                            {item.href === '/card' ? '利用額200円ごとに' : '利用料金の'}
                          </span>
                          <span className="text-headline-s">{numberMap[item.href]}</span>
                          <span className="text-caption-m-bold">{item.href === '/card' ? '枚' : '%分'}</span>
                          <span className="text-caption-s align-super">※</span>
                        </>
                      )}
                    </p>
                    <p className="text-caption-m-bold text-grey-800">株引換券がもらえる</p>
                  </div>
                  <Button asChild className={buttonStyles.outline.md}>
                    <a href={`${import.meta.env.VITE_APP_KABUAND_URL}${item.href}`} aria-label={`${item.label}の詳細`}>
                      詳しく見る
                    </a>
                  </Button>
                  {item.href !== '/kabukatsu' && <SiteModalPlusMember />}
                </div>
                {item.href === '/card' && (
                  <p className="text-caption-s text-grey-500 text-center">（カブアンドサービス内）</p>
                )}
              </div>
            </CarouselItem>
          );
        })}
    </>
  );
};
